module.exports = __webpack_public_path__ + "img/28.a51af6ae.png";